import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AlertCircle } from "lucide-react";

/** Compact tile on Dashboard — hidden if the user has no pending mistakes. */
export default function MistakeTile() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/mistake-practice/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats || stats.pending === 0) return null;

  return (
    <Link
      to="/mistakes"
      className="block border border-brand-crimson/40 bg-brand-crimson/10 rounded-2xl p-5 mb-8 hover:border-brand-crimson transition-colors group"
      data-testid="mistake-tile"
    >
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 border border-brand-crimson/40 bg-background/60 rounded-xl flex items-center justify-center shrink-0">
          <AlertCircle className="w-5 h-5 text-brand-crimson" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-brand-crimson mb-1">Fix your mistakes</div>
          <div className="font-display text-lg sm:text-xl font-black tracking-tight">
            {stats.pending} sentence{stats.pending === 1 ? "" : "s"} waiting to be drilled
          </div>
          <div className="text-[11px] font-mono text-muted-foreground mt-1">Master each one at 95%+ to move on</div>
        </div>
        <div className="text-xs uppercase tracking-widest font-bold text-brand-crimson group-hover:translate-x-1 transition-transform">
          Start drill →
        </div>
      </div>
    </Link>
  );
}
